export class Dimension {
  code: string;
  unit: string;
  length: string;
  width: string;
  height: string;
  constructor() {
  }
}
